import { App, message as staticMessage, notification as staticNotification } from "antd";

// antd's static message/notification render outside ConfigProvider, so they
// ignore the app theme (light toasts in dark mode). This bridge captures the
// theme-aware instances from antd's <App> context; until it mounts, calls
// fall back to the antd statics so nothing breaks (e.g. in tests).
let message = staticMessage;
let notification = staticNotification;

const AntdStaticBridge = () => {
  const app = App.useApp();
  message = app.message;
  notification = app.notification;
  return null;
};

export { message, notification };
export default AntdStaticBridge;
